import type { BlogAuthor } from "../types";
import { Monogram } from "@/features/portal/components/portal-ui";
import { BrandMark } from "@/features/site/components/brand-mark";
import { cn } from "@/lib/utils";
import { BlogAuthorKind } from "@complete-athlete/enums";

/** An author's face: their portrait, the brand mark for the team, or their initials. */
export const AuthorAvatar = ({ author, className }: { author: Pick<BlogAuthor, "name" | "kind" | "avatarUrl">; className?: string }) => {
  if (author.avatarUrl) {
    return (
      <img
        src={author.avatarUrl}
        alt=""
        loading="lazy"
        decoding="async"
        className={cn("size-8 shrink-0 rounded-full bg-muted object-cover", className)}
      />
    );
  }
  if (author.kind === BlogAuthorKind.TEAM) {
    return <BrandMark className={cn("size-8 rounded-full [&_svg]:h-[15px]", className)} />;
  }
  return <Monogram name={author.name} className={cn("size-8 rounded-full text-[11px]", className)} />;
};
